import { styled } from '@mui/material/styles'

type IconProps = {
	color: string
}

export const StyledIconWrapper = styled('div')({
	flex: 1,
})

export namespace CustomIcon {
	export function LightLogo() {
		return (
			<svg
				width="113"
				height="37"
				viewBox="0 0 113 37"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M43.0946 14.09C40.7006 16.978 40.7006 19.068 43.0946 22.07L49.0226 29.404C50.0866 30.658 50.6946 31 52.3666 31H53.0506C54.6846 31 54.8366 30.734 53.8106 29.404L46.7426 20.626C46.0206 19.714 45.6026 19.144 45.4126 18.878C45.2226 18.612 45.1466 18.346 45.1466 18.118C45.1466 17.852 45.2226 17.548 45.4126 17.282C45.6026 17.016 46.0206 16.446 46.7426 15.572L53.0506 7.896C54.1146 6.566 53.9626 6.3 52.2906 6.3H51.6066C49.9726 6.3 49.3266 6.642 48.2626 7.896L43.0946 14.09ZM35.8746 29.252C35.8746 30.658 36.2166 31 37.6226 31H38.1166C39.5226 31 39.8646 30.658 39.8646 29.252V8.048C39.8646 6.642 39.5226 6.3 38.1166 6.3H37.6226C36.2166 6.3 35.8746 6.642 35.8746 8.048V29.252ZM61.1811 13.862C61.1811 12.494 60.8391 12.152 59.4711 12.152H58.9771C57.6091 12.152 57.2671 12.494 57.2671 13.862V24.008C57.2671 28.948 60.0411 31.418 65.5511 31.418C71.2131 31.418 73.7971 28.986 73.7971 24.008V13.862C73.7971 12.494 73.4551 12.152 72.0871 12.152H71.5931C70.2251 12.152 69.8831 12.494 69.8831 13.862V24.008C69.8831 26.706 68.8571 27.732 65.5511 27.732C62.2451 27.732 61.1811 26.706 61.1811 24.008V13.862ZM81.2873 13.824C80.9833 12.494 80.5653 12.152 79.1973 12.152H78.6273C77.2593 12.152 76.9933 12.494 77.3353 13.824L80.3753 26.364C80.8313 28.264 81.4393 29.594 82.1613 30.316C82.8833 31.038 84.2133 31.38 86.1513 31.38C88.0893 31.38 89.4193 31 90.1413 30.278C90.8633 29.556 91.4713 28.226 91.9273 26.364L94.9673 13.824C95.3093 12.494 95.0433 12.152 93.6753 12.152H93.1053C91.7373 12.152 91.3193 12.494 91.0153 13.824L88.0513 26.174C87.7093 27.656 87.3293 27.998 86.1513 27.998C85.0493 27.998 84.5933 27.58 84.2513 26.174L81.2873 13.824ZM112.986 17.966C112.986 13.558 110.06 11.734 104.398 11.734C103.144 11.734 101.852 11.848 100.598 12.038C99.5341 12.228 99.2301 12.57 99.2301 13.672V14.204C99.2301 15.382 99.5341 15.61 100.636 15.42C101.776 15.192 103.106 15.078 104.626 15.078C107.78 15.078 109.11 15.8 109.11 17.966V19.828H104.93C99.8001 19.828 97.1781 21.576 97.1781 25.566C97.1781 29.48 99.7621 31.418 104.892 31.418C110.516 31.418 112.986 29.556 112.986 25.338V17.966ZM109.11 25.148C109.11 27.428 107.856 28.112 104.816 28.112C102.384 28.112 101.092 27.428 101.092 25.49C101.092 23.552 102.308 22.792 104.93 22.792H109.11V25.148Z"
					fill="#140A5A"
				/>
				<path
					d="M25.0466 34.658L14.4492 20.3164L9.15405 27.7236C7.92408 29.4441 7.94413 31.7607 9.20371 33.4597L10.1126 34.6857C11.1351 36.065 12.7515 36.8785 14.4694 36.8785H23.9249C25.069 36.8785 25.7261 35.5776 25.0466 34.658Z"
					fill="url(#paint0_linear_0_68924)"
				/>
				<path
					d="M24.411 0.222656H13.79C12.9017 0.222656 12.0666 0.645486 11.5413 1.36118L1.04869 15.6576C-0.328075 17.5335 -0.352636 20.0781 0.987657 21.9802L6.76134 30.1738C6.76134 28.9911 7.13267 27.8383 7.82296 26.8777L25.4806 2.3057C26.1061 1.43523 25.4835 0.222656 24.411 0.222656Z"
					fill="url(#paint1_linear_0_68924)"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_0_68924"
						x1="20.4427"
						y1="37.4076"
						x2="11.2888"
						y2="24.5345"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#005AF4" />
						<stop offset="1" stopColor="#094EC2" />
					</linearGradient>
					<linearGradient
						id="paint1_linear_0_68924"
						x1="2.32341"
						y1="23.306"
						x2="11.6212"
						y2="11.4944"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#2EB3ED" />
						<stop offset="1" stopColor="#29EEFD" />
					</linearGradient>
				</defs>
			</svg>
		)
	}

	export function DarkLogo() {
		return (
			<svg
				width="113"
				height="37"
				viewBox="0 0 113 37"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M43.0946 14.09C40.7006 16.978 40.7006 19.068 43.0946 22.07L49.0226 29.404C50.0866 30.658 50.6946 31 52.3666 31H53.0506C54.6846 31 54.8366 30.734 53.8106 29.404L46.7426 20.626C46.0206 19.714 45.6026 19.144 45.4126 18.878C45.2226 18.612 45.1466 18.346 45.1466 18.118C45.1466 17.852 45.2226 17.548 45.4126 17.282C45.6026 17.016 46.0206 16.446 46.7426 15.572L53.0506 7.896C54.1146 6.566 53.9626 6.3 52.2906 6.3H51.6066C49.9726 6.3 49.3266 6.642 48.2626 7.896L43.0946 14.09ZM35.8746 29.252C35.8746 30.658 36.2166 31 37.6226 31H38.1166C39.5226 31 39.8646 30.658 39.8646 29.252V8.048C39.8646 6.642 39.5226 6.3 38.1166 6.3H37.6226C36.2166 6.3 35.8746 6.642 35.8746 8.048V29.252ZM61.1811 13.862C61.1811 12.494 60.8391 12.152 59.4711 12.152H58.9771C57.6091 12.152 57.2671 12.494 57.2671 13.862V24.008C57.2671 28.948 60.0411 31.418 65.5511 31.418C71.2131 31.418 73.7971 28.986 73.7971 24.008V13.862C73.7971 12.494 73.4551 12.152 72.0871 12.152H71.5931C70.2251 12.152 69.8831 12.494 69.8831 13.862V24.008C69.8831 26.706 68.8571 27.732 65.5511 27.732C62.2451 27.732 61.1811 26.706 61.1811 24.008V13.862ZM81.2873 13.824C80.9833 12.494 80.5653 12.152 79.1973 12.152H78.6273C77.2593 12.152 76.9933 12.494 77.3353 13.824L80.3753 26.364C80.8313 28.264 81.4393 29.594 82.1613 30.316C82.8833 31.038 84.2133 31.38 86.1513 31.38C88.0893 31.38 89.4193 31 90.1413 30.278C90.8633 29.556 91.4713 28.226 91.9273 26.364L94.9673 13.824C95.3093 12.494 95.0433 12.152 93.6753 12.152H93.1053C91.7373 12.152 91.3193 12.494 91.0153 13.824L88.0513 26.174C87.7093 27.656 87.3293 27.998 86.1513 27.998C85.0493 27.998 84.5933 27.58 84.2513 26.174L81.2873 13.824ZM112.986 17.966C112.986 13.558 110.06 11.734 104.398 11.734C103.144 11.734 101.852 11.848 100.598 12.038C99.5341 12.228 99.2301 12.57 99.2301 13.672V14.204C99.2301 15.382 99.5341 15.61 100.636 15.42C101.776 15.192 103.106 15.078 104.626 15.078C107.78 15.078 109.11 15.8 109.11 17.966V19.828H104.93C99.8001 19.828 97.1781 21.576 97.1781 25.566C97.1781 29.48 99.7621 31.418 104.892 31.418C110.516 31.418 112.986 29.556 112.986 25.338V17.966ZM109.11 25.148C109.11 27.428 107.856 28.112 104.816 28.112C102.384 28.112 101.092 27.428 101.092 25.49C101.092 23.552 102.308 22.792 104.93 22.792H109.11V25.148Z"
					fill="white"
				/>
				<path
					d="M25.0466 34.658L14.4492 20.3164L9.15405 27.7236C7.92408 29.4441 7.94413 31.7607 9.20371 33.4597L10.1126 34.6857C11.1351 36.065 12.7515 36.8785 14.4694 36.8785H23.9249C25.069 36.8785 25.7261 35.5776 25.0466 34.658Z"
					fill="white"
				/>
				<path
					d="M24.411 0.222656H13.79C12.9017 0.222656 12.0666 0.645486 11.5413 1.36118L1.04869 15.6576C-0.328075 17.5335 -0.352636 20.0781 0.987657 21.9802L6.76134 30.1738C6.76134 28.9911 7.13267 27.8383 7.82296 26.8777L25.4806 2.3057C26.1061 1.43523 25.4835 0.222656 24.411 0.222656Z"
					fill="white"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_0_68924"
						x1="20.4427"
						y1="37.4076"
						x2="11.2888"
						y2="24.5345"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="1" stopColor="white" />
					</linearGradient>
					<linearGradient
						id="paint1_linear_0_68924"
						x1="2.32341"
						y1="23.306"
						x2="11.6212"
						y2="11.4944"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="1" stopColor="white" />
					</linearGradient>
				</defs>
			</svg>
		)
	}

	export function DarkCloseSearch() {
		return (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle cx="12" cy="12" r="12" fill="#2A3144" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16.0099 17.8751C16.5249 18.39 17.3599 18.39 17.8748 17.8751C18.3898 17.3601 18.3898 16.5251 17.8748 16.0102L13.8649 12.0002L17.875 7.99002C18.39 7.47505 18.39 6.6401 17.875 6.12513C17.36 5.61015 16.5251 5.61015 16.0101 6.12513L12 10.1353L7.99088 6.12622C7.4759 5.61124 6.64096 5.61124 6.12598 6.12622C5.611 6.64119 5.611 7.47614 6.12598 7.99111L10.1351 12.0002L6.12618 16.0091C5.6112 16.5241 5.6112 17.359 6.12618 17.874C6.64115 18.389 7.4761 18.389 7.99107 17.874L12 13.8651L16.0099 17.8751Z"
					fill="#E6E6E6"
				/>
			</svg>
		)
	}

	export function LightCloseSearch() {
		return (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle cx="12" cy="12" r="12" fill="#5A5A5A" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16.0099 17.8751C16.5249 18.39 17.3599 18.39 17.8748 17.8751C18.3898 17.3601 18.3898 16.5251 17.8748 16.0102L13.8649 12.0002L17.875 7.99002C18.39 7.47505 18.39 6.6401 17.875 6.12513C17.36 5.61015 16.5251 5.61015 16.0101 6.12513L12 10.1353L7.99088 6.12622C7.4759 5.61124 6.64096 5.61124 6.12598 6.12622C5.611 6.64119 5.611 7.47614 6.12598 7.99111L10.1351 12.0002L6.12618 16.0091C5.6112 16.5241 5.6112 17.359 6.12618 17.874C6.64115 18.389 7.4761 18.389 7.99107 17.874L12 13.8651L16.0099 17.8751Z"
					fill="#EAF6FE"
				/>
			</svg>
		)
	}

	export function FlagGB() {
		return (
			<svg
				width="32"
				height="24"
				viewBox="0 0 32 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_35366_27211)">
					<mask
						id="mask0_35366_27211"
						//style="mask-type:alpha"
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="32"
						height="24"
					>
						<path d="M0 0H32V24H0V0Z" fill="white" />
					</mask>
					<g mask="url(#mask0_35366_27211)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M0 0V24H32V0H0Z"
							fill="#2E42A5"
						/>
						<mask
							id="mask1_35366_27211"
							//style="mask-type:alpha"
							maskUnits="userSpaceOnUse"
							x="0"
							y="0"
							width="32"
							height="24"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M0 0V24H32V0H0Z"
								fill="white"
							/>
						</mask>
						<g mask="url(#mask1_35366_27211)">
							<mask
								id="mask2_35366_27211"
								//style="mask-type:alpha"
								maskUnits="userSpaceOnUse"
								x="0"
								y="0"
								width="32"
								height="24"
							>
								<path d="M0 0H32V24H0V0Z" fill="white" />
							</mask>
							<g mask="url(#mask2_35366_27211)">
								<path
									d="M-3.56299 22.2844L3.47901 25.2634L32.159 3.23741L35.874 -1.18859L28.344 -2.18359L16.646 7.30741L7.23001 13.7034L-3.56299 22.2844Z"
									fill="white"
								/>
								<path
									d="M-2.6001 24.3733L0.988902 26.1013L34.5399 -1.59766H29.5029L-2.5991 24.3723L-2.6001 24.3733Z"
									fill="#F50100"
								/>
								<path
									d="M35.563 22.2844L28.521 25.2634L-0.159023 3.23741L-3.87402 -1.18859L3.65598 -2.18359L15.354 7.30741L24.77 13.7034L35.563 22.2844Z"
									fill="white"
								/>
								<path
									d="M35.3231 23.7841L31.7351 25.5121L17.4491 13.6521L13.2131 12.3281L-4.23193 -1.17188H0.806067L18.2401 12.0081L22.8711 13.5961L35.3231 23.7841Z"
									fill="#F50100"
								/>
								<mask
									id="mask3_35366_27211"
									//style="mask-type:alpha"
									maskUnits="userSpaceOnUse"
									x="-2"
									y="-2"
									width="37"
									height="28"
								>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M19.7778 -2H12.2218V8H-1.97217V16H12.2218V26H19.7778V16H34.0278V8H19.7778V-2Z"
										fill="white"
									/>
								</mask>
								<g mask="url(#mask3_35366_27211)">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M19.7778 -2H12.2218V8H-1.97217V16H12.2218V26H19.7778V16H34.0278V8H19.7778V-2Z"
										fill="#F50100"
									/>
									<path
										d="M12.2218 -2V-4H10.2218V-2H12.2218ZM19.7778 -2H21.7778V-4H19.7778V-2ZM12.2218 8V10H14.2218V8H12.2218ZM-1.97217 8V6H-3.97217V8H-1.97217ZM-1.97217 16H-3.97217V18H-1.97217V16ZM12.2218 16H14.2218V14H12.2218V16ZM12.2218 26H10.2218V28H12.2218V26ZM19.7778 26V28H21.7778V26H19.7778ZM19.7778 16V14H17.7778V16H19.7778ZM34.0278 16V18H36.0278V16H34.0278ZM34.0278 8H36.0278V6H34.0278V8ZM19.7778 8H17.7778V10H19.7778V8ZM12.2218 0H19.7778V-4H12.2218V0ZM14.2218 8V-2H10.2218V8H14.2218ZM-1.97217 10H12.2218V6H-1.97217V10ZM0.027832 16V8H-3.97217V16H0.027832ZM12.2218 14H-1.97217V18H12.2218V14ZM14.2218 26V16H10.2218V26H14.2218ZM19.7778 24H12.2218V28H19.7778V24ZM17.7778 16V26H21.7778V16H17.7778ZM34.0278 14H19.7778V18H34.0278V14ZM32.0278 8V16H36.0278V8H32.0278ZM19.7778 10H34.0278V6H19.7778V10ZM17.7778 -2V8H21.7778V-2H17.7778Z"
										fill="white"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_35366_27211">
						<rect width="32" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		)
	}

	export function VerifiedStatus() {
		return (
			<svg
				width="11"
				height="10"
				viewBox="0 0 11 10"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle cx="5.05273" cy="5" r="5" fill="#28E5AA" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.00073 5.37119L3.66171 4.70475L4.4361 5.39145L6.56438 3.46094L7.10479 4.13539L4.41752 6.53861L3.00073 5.37119Z"
					fill="white"
				/>
			</svg>
		)
	}

	export function NotPermittedStatus() {
		return (
			<svg
				width="11"
				height="10"
				viewBox="0 0 11 10"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle cx="5.03809" cy="5" r="5" fill="#EB5757" />
			</svg>
		)
	}

	export function MasterAgent({ color }: IconProps) {
		return (
			<svg
				width="39"
				height="20"
				viewBox="0 0 39 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M28.5333 6.46667C27.5962 5.52957 26.3253 5.00311 25 5.00311C23.6747 5.00311 22.4038 5.52957 21.4667 6.46667C20.5296 7.40376 20.0031 8.67474 20.0031 10C20.0031 11.3253 20.5296 12.5962 21.4667 13.5333C21.9307 13.9973 22.4815 14.3654 23.0878 14.6165C23.694 14.8676 24.3438 14.9969 25 14.9969C25.6562 14.9969 26.306 14.8676 26.9122 14.6165C27.5185 14.3654 28.0693 13.9973 28.5333 13.5333C28.9973 13.0693 29.3654 12.5185 29.6165 11.9122C29.8676 11.306 29.9969 10.6562 29.9969 10C29.9969 9.3438 29.8676 8.69402 29.6165 8.08777C29.3654 7.48152 28.9973 6.93067 28.5333 6.46667ZM11.6667 0V20H38.3333V0H11.6667ZM35 13.3333C34.1167 13.3333 33.2667 13.6833 32.65 14.3167C32.0167 14.9333 31.6667 15.7833 31.6667 16.6667H18.3333C18.3333 15.7833 17.9833 14.9333 17.35 14.3167C16.7333 13.6833 15.8833 13.3333 15 13.3333V6.66667C15.8833 6.66667 16.7333 6.31667 17.35 5.68333C17.9833 5.06667 18.3333 4.21667 18.3333 3.33333H31.6667C31.6667 4.21667 32.0167 5.06667 32.65 5.68333C33.2667 6.31667 34.1167 6.66667 35 6.66667V13.3333ZM8.33333 3.33333H5C4.08333 3.33333 3.33333 2.58333 3.33333 1.66667C3.33333 0.75 4.08333 0 5 0H8.33333V3.33333ZM8.33333 11.6667H3.33333C2.41667 11.6667 1.66667 10.9167 1.66667 10C1.66667 9.08333 2.41667 8.33333 3.33333 8.33333H8.33333V11.6667ZM8.33333 20H1.66667C0.746667 20 0 19.25 0 18.3333C0 17.4167 0.746667 16.6667 1.66667 16.6667H8.33333V20Z"
					fill={color}
				/>
			</svg>
		)
	}
}
